export class PaySupplementNotAllowedError extends Error {
  constructor(reason: string) {
    super(`Pay supplement is not allowed: ${reason}.`);
    Object.setPrototypeOf(this, PaySupplementNotAllowedError.prototype);
  }
}
